var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.13934 2.05357L7.08579 6.00001L3.13934 9.94646L3.84645 10.6536L8.5 6.00001L3.84645 1.34646L3.13934 2.05357Z","fill":"black"}));
}

ChevronLeft.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
